import React, { useState, useEffect, useContext } from 'react';
import { Paper, Box, Avatar, Grid, Chip, Typography, Button, CircularProgress, Pagination } from '@mui/material';
import { DataGrid } from "@mui/x-data-grid";
import ApiService from '../../functions/apiService';
import moment from 'moment';
import './position-assign.css'
import { toast } from 'react-toastify';
import { varFormatTime } from '../../utils/helperFunctions';
import AuthContext from '../../context/AuthContext';
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import Modal from 'react-bootstrap/Modal';
import { Col, Row } from 'react-bootstrap';

const CancelledAssignments = () => {
	const { user } = useContext(AuthContext);
	const timeFormat = (timeStr) => timeStr?.slice(0, 5);
	const [loading, setLoading] = useState(false);
	const [assignmentList, setAssignmentList] = useState('');
	const [totalPages, setTotalPages] = useState(1);
	const [currentPage, setCurrentPage] = useState(1);
	const [reasonModal, setReasonModal] = useState(false);
	const [reason, setReason] = useState('');

	const checkButtonStyle = {
		color: "#555555",
		minWidth: "0",
		paddingRight: ".02rem",
		":hover": { color: "green", background: "none" },
	};

	const clearButtonStyle = {
		color: "#555555",
		minWidth: "0",
		paddingRight: ".02rem",
		":hover": { color: "red", background: "none" },
	};

	const columns = [
		{
			field: 'Assignment_date', headerName: 'Date', flex: 1, minWidth: 180,
			valueGetter: (params) => {
				return moment(params?.row?.Shift_Date).format('ddd Do MMMM YYYY');
			}
		},

		{
			field: 'name', headerName: 'Name', flex: 1, minWidth: 200,
			valueGetter: (params) => {
				return (params?.row?.employee?.employee_assignment?.EA_Rank + " " + params?.row?.employee?.fullName)
			}
		},

		{
			field: 'Shift', headerName: 'Shift', flex: 1, minWidth: 280,
			renderCell: (params) => {
				return `${(params?.row?.Shift_Code == '2') ? 'DAY' : (params?.row?.Shift_Code == '3') ? 'NIGHT' : "EVENING"} (${varFormatTime(timeFormat(params?.row?.Start_Time), user?.Time_Format)} - ${varFormatTime(timeFormat(params?.row?.End_Time), user?.Time_Format)})`;
			}
		},

		{
			field: 'Position', headerName: 'Position', flex: 1, minWidth: 140,
			valueGetter: (params) => {
				return (params?.row?.position_assignments?.position_name?.SO_Desc)
			}
		},

		{
			field: 'Assignment', headerName: 'Assignment', flex: 1, minWidth: 140,
			renderCell: (params) => {
				return (params?.row?.position_assignments?.assignment_name?.SO_Desc)
			}
		},

		{
			field: '24Hours', headerName: 'Cancellation', flex: 1, minWidth: 140,
			renderCell: (params) => {
				return (params?.row?.IsWithin24Hours == true ?
					<Chip style={{ width: '125px' }}
						color={'warning'}
						label={"Within 24 hours"} />
					: '')
			}
		},

		// {
		// 	field: 'reason', headerName: '', flex: 1, minWidth: 180,
		// 	renderCell: (params) => {
		// 		return (params?.row?.Reason)
		// 	}
		// },

		{
			field: "reason",
			headerName: "Reason",
			flex: 1,
			minWidth: 100,
			renderCell: (params) => {
				const rejectReason = params?.row?.Reason;
				return (
					<>
						{rejectReason &&
							<Button
								onClick={() => {
									setReason(rejectReason);
									setTimeout(() => setReasonModal(true), 500);
								}}
								sx={checkButtonStyle}
								startIcon={
									<Avatar
										src="/images/eye.svg"
										style={{ width: 28, height: 24, padding: 1, marginLeft: '6px' }}
									/>
								}
							/>
						}
					</>
				);
			},
		},

		{
			field: 'action',
			headerName: 'Action',
			flex: 1,
			minWidth: 140,
			renderCell: (params) => {
				return params?.row?.Status === 'pending' ? (
					<>
						<Button
							onClick={() => shiftAction(params?.row?.ID, 'accepted')}
							sx={checkButtonStyle}
							startIcon={<CheckIcon />}
						></Button>

						<Button
							onClick={() => shiftAction(params?.row?.ID, 'rejected')}
							sx={clearButtonStyle}
							startIcon={<ClearIcon />}
						></Button>
					</>
				) : params?.row?.Status === 'accepted' ? (
					<Chip style={{ width: '80px' }}
						color={'DarkGreen'}
						label={"Accepted"} />
				) : (
					<Chip style={{ width: '80px' }}
						color={'primary'}
						label={"Rejected"} />
				);
			},
		}
	]

	const getAssignmentList = () => {
		ApiService.get(`/positionAssignmentFillCancelRequestsList?page=${currentPage}`)
			.then(({ data }) => {
				setAssignmentList(data?.data?.data);
				setTotalPages(Math.ceil(data?.data?.total / data?.data?.per_page));
				setLoading(false);
			})
			.catch((e) => {
				setLoading(false);
			});
	}

	const handlePageChange = (_, value) => {
		setCurrentPage(value);
	}

	const shiftAction = (id, status) => {
		ApiService.post("/updatePositionAssignmentFillCancelRequestsStatus", {
			"Position_Assignments_Fill_Id": id,
			"Status": status
		})
			.then((data) => {
				toast.success(data?.message)
				getAssignmentList(false)
			})
			.catch((error) => {
				toast.error(error?.data?.message)
			});
	}

	useEffect(() => {
		getAssignmentList()
	}, [])

	useEffect(() => {
		getAssignmentList()
	}, [currentPage])

	return (
		<>
			{loading ? (
				<Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
					<CircularProgress />
				</Paper>
			) : (
				<Paper className="p-4 font-fam" style={{ marginTop: "1rem" }}>
					<Grid container spacing={2}>

						{/* Heading */}
						<Grid item xs={10} md={9}>
							<Typography variant="h5">Cancelled Assignments</Typography>
						</Grid>

						{/* Search field */}
						{/* <Grid item xs={12} sm={12} md={3}>
							<TextField
								variant="outlined"
								placeholder="Search"
								onChange={(e) => setSearchResult(e.target.value)}
								className="w-100"
								InputProps={{
									endAdornment: (
										<InputAdornment position="end">
											<IconButton>
												<SearchIcon />
											</IconButton>
										</InputAdornment>
									),
									sx: {
										height: '48px',
										fontSize: '14px',
										marginRight: '10px',
									},
								}}
							/>
						</Grid> */}

					</Grid>

					{(!assignmentList || assignmentList.length == 0) ?
						<div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 565 }}>
							<img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
							<span className='mt-4' style={{ color: '#555555' }}>
								No Cancelled Assignments Found
							</span>
						</div>
						:
						<>
							<div className='mt-4'>
								<DataGrid
									rows={assignmentList}
									columns={columns}
									checkboxSelection={false}
									hideFooter={true}
									getRowId={assignmentList?.id}
								/>
							</div>
							<Pagination
								count={totalPages}
								page={currentPage}
								onChange={handlePageChange}
								color="primary"
								className="mt-4 d-flex"
								style={{ justifyContent: 'end' }}
							/>
						</>
					}
				</Paper >
			)}

			{/* Reason Modal */}
			<Modal show={reasonModal} size="md"
				onHide={() => { setReasonModal(false) }}>
				<Modal.Header closeButton>
					<Modal.Title>Reason for Cancellation</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<Row className='w-100 m-auto' style={{ flexWrap: 'wrap' }}>
						<div className="p-0" style={{ color: '#000', marginBottom: '12px' }}>
							{reason ? reason : ''}
						</div>
					</Row>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default CancelledAssignments